import { createAuthTransportPort } from '@/modules/auth/public'
import { setAuthPort } from '@/shared/api/auth-port'

export function configureAuthTransport(): void {
  setAuthPort(createAuthTransportPort())
}
